import { colors } from "../../theme";
import { brandRgba } from "../../utils/brandAssets";
import { SPORT_BY_ID } from "../../constants/sportWorkspace";

export const fanHubSectionSx = {
  mb: 4,
};

export const fanHubOverlineSx = {
  letterSpacing: "0.16em",
  color: "text.secondary",
};

export const fanHubPaperSx = (accent) => ({
  borderRadius: 2.5,
  border: `1px solid ${colors.border}`,
  background: accent
    ? `linear-gradient(180deg, ${brandRgba(accent, 0.08)} 0%, ${colors.paper} 42%)`
    : colors.paper,
  overflow: "hidden",
});

export const fanHubTileSx = (accent) => ({
  minWidth: 108,
  width: 108,
  flex: "0 0 auto",
  p: 1.25,
  borderRadius: 2,
  border: `1px solid ${colors.border}`,
  bgcolor: "rgba(255,255,255,0.02)",
  textAlign: "center",
  textDecoration: "none",
  color: "inherit",
  position: "relative",
  transition: "border-color 0.2s ease, transform 0.2s ease",
  "&:hover": {
    borderColor: brandRgba(accent || "#84E6E5", 0.45),
    transform: "translateY(-2px)",
  },
});

export const fanHubAddTileSx = {
  minWidth: 108,
  width: 108,
  flex: "0 0 auto",
  p: 1.25,
  borderRadius: 2,
  border: `1px dashed ${colors.border}`,
  color: "text.secondary",
  bgcolor: "transparent",
  minHeight: 124,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.75,
  cursor: "pointer",
  font: "inherit",
  "&:hover": {
    borderColor: "text.secondary",
    color: "text.primary",
  },
};

export const sportAccent = (sport) => SPORT_BY_ID[sport]?.accent || "#84E6E5";

export const fanHubDialogPaperSx = (accent) => ({
  ...fanHubPaperSx(accent),
  backgroundImage: "none",
});

export const fanHubPageGlowSx = (accent) => ({
  position: "relative",
  pb: 8,
  "&::before": {
    content: '""',
    position: "absolute",
    top: -120,
    left: "50%",
    width: 720,
    height: 360,
    transform: "translateX(-50%)",
    background: `radial-gradient(closest-side, ${brandRgba(accent, 0.2)}, transparent 72%)`,
    pointerEvents: "none",
    zIndex: 0,
  },
});
